import React from 'react';

export const C = ({ x, o, c, h, l, w = 12 }) => {
  const bull = c <= o;
  const col  = bull ? '#16C784' : '#ef4444';
  const bTop = Math.min(o, c);
  const bH   = Math.max(Math.abs(c - o), 2);
  return (
    <g>
      <line x1={x + w / 2} y1={h} x2={x + w / 2} y2={l} stroke={col} strokeWidth="1.5" />
      <rect x={x} y={bTop} width={w} height={bH} fill={col} rx="1" />
    </g>
  );
};

export const HL = ({ y, x1 = 5, x2 = 195, color = '#94a3b8', dash = false }) => (
  <line x1={x1} y1={y} x2={x2} y2={y} stroke={color} strokeWidth="1.5"
    strokeDasharray={dash ? '5,3' : 'none'} />
);

export const Lbl = ({ x, y, text, color = '#94a3b8', anchor = 'middle', size = 8 }) => (
  <text x={x} y={y} fill={color} fontSize={size} textAnchor={anchor}
    fontFamily="ui-monospace,monospace">{text}</text>
);

export const Div = () => (
  <line x1="100" y1="5" x2="100" y2="105" stroke="#334155" strokeWidth="1" strokeDasharray="3,3" />
);

